import { styled } from 'twin.macro';
import { ImageProps } from '.';
import { getStylesFromProps } from '../../core/utils';

export default styled.img<ImageProps>`
    object-fit: ${({ fit }) => fit};
    ${(props) => getStylesFromProps(props)};
`;
